import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import user from './modules/user'
import texture from './modules/texture'
import permission from './modules/permission'
import template from './modules/template'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    template,
    texture
  },
  state: {

  },
  mutations: {

  },
  actions: {

  },
  getters
})
